module.exports = __webpack_public_path__ + "img/more_vert.771b2e86.svg";